import type { Condition } from '@repo/api-gw-sdk';

import { isCombineCondition } from '@/types/advanceFilter';

export const toJsonText = function (query: Condition): string {
  if (!query) {
    return '';
  }

  return JSON.stringify(query, (key, value) => {
    if (isCombineCondition(value) && !value.conditions?.length) {
      return undefined;
    }
    return value;
  });
};
